import { MstImportTmpl } from '@libs/templates/mst';
import type { ItemName, PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { importFunction } from './repositories';

function PageComponent(props: PageProps & { itemName: ItemName }) {
  return <MstImportTmpl mstName={props.itemName} importFunction={importFunction} {...props} />;
}

export const Import = withRerender(PageComponent, 'Import');
